import { FormField, Label, Paragraph } from '@zillow/constellation-10';
import type { AvailabilityDate, TimeZoneIds } from '@zg-rentals/touring';
import { TourAvailabilityCards } from '@zg-rentals/touring';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type TourSchedulingAvailabilityBodyProps = {
  availabilityDates: Array<AvailabilityDate>;
  onAvailabilityDatesChange: (availabilityDates: Array<AvailabilityDate>) => void;
  timeZone: TimeZoneIds;
  tourDuration?: TourDuration;
};

const TourSchedulingAvailabilityBody = ({
  availabilityDates,
  onAvailabilityDatesChange,
  timeZone,
  tourDuration,
}: TourSchedulingAvailabilityBodyProps) => {
  return (
    <div data-testid="TourSchedulingAvailabilityBody">
      <WizardFormSectionContainer>
        <WizardHeading level={1} textStyle="heading-sm" data-testid="TourSchedulingAvailabilityBody-Heading">
          When are you free for tours?
        </WizardHeading>
        <WizardBody>
          <Paragraph data-testid="TourSchedulingAvailabilityBody-Description">
            Add a few dates and times up to three weeks from today. Then you can start booking tours as soon as your
            listing&apos;s live. We recommend you add more after your listing is published.
          </Paragraph>
        </WizardBody>

        <FormField
          label={<Label size="lg">Tour availability</Label>}
          required={true}
          css={{ marginBottom: 'default' }}
        />
        <TourAvailabilityCards
          availabilityDates={availabilityDates}
          onAvailabilityDatesChange={onAvailabilityDatesChange}
          timeZone={timeZone}
          tourDuration={tourDuration}
        />
      </WizardFormSectionContainer>
    </div>
  );
};

export default TourSchedulingAvailabilityBody;
